"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brightnessAndContrastAdjustment = brightnessAndContrastAdjustment;

var _transformImage = require("./transformImage");
/**
 * Changes the contrast and the brightness of the given image
 *
 * @param {RgbaImageBuffer} imgBuffer Image to transform
 * @param {number[]} oldBrightnesses Previous brightnesses of the image
 * @param {number[]} oldContrasts Previous contrasts of the image
 * @param {number[]} newBrightnesses New brightnesses of the image
 * @param {number[]} newContrasts New contrasts of the image
 * @returns {RgbaImageBuffer} Transformed image
 */


function brightnessAndContrastAdjustment(imgBuffer, oldBrightnesses, oldContrasts, newBrightnesses, newContrasts) {
  var lookupTable = (0, _transformImage.createLookupTable)(function (dim) {
    var slope = newContrasts[dim] / oldContrasts[dim];
    var yIntercept = newBrightnesses[dim] - slope * oldBrightnesses[dim];
    return function (value) {
      var newValue = Math.round(slope * value + yIntercept);
      var clippedValue = Math.min(Math.max(newValue, 0), 255);
      return clippedValue;
    };
  });
  return (0, _transformImage.applyLookupTable)(imgBuffer, lookupTable);
}